import React, { useEffect, useState } from "react";
import {
    Button,
    Input,
    Form,
    message,
} from "antd";
import styles from './index.module.scss';
import classnames from 'utils/classNames';
import userIcon from 'assets/icons/icon-user.png';
import pswIcon from 'assets/icons/icon-psw.png';
import { useHistory } from 'react-router-dom'
import { cookie } from "approach/base";


function UserLogin() {
  const { userLogin } = window.$axios.request;
  const [forms] = Form.useForm();
  const history = useHistory()
  const [loading,setLoading] = useState(false);

  useEffect(() => {
  }, [])

  const onFinish = (values) => {
    setLoading(true);
    userLogin({},values).then((res) =>{
      setLoading(false);
      if(res.result == 0){
        const { sysMenuList, accessToken, refreshToken, userName } = res.retVal;
        cookie.set('accessToken', accessToken)
        cookie.set('refreshToken', refreshToken)
        cookie.set('userNo', values.userName)
        cookie.set('userName', userName)
        cookie.set('loginStatus', true)
        cookie.set('sysMenuList', JSON.stringify(sysMenuList))
        if(sysMenuList.length > 0){
            let perms = sysMenuList[0].children[0].children.map(e => e.perms)
            history.push('/manage/bidding');
        }else{
            message.error("无权限");
        }
        
      }else{
        message.error(res.msg);
      }
    }).catch((err) =>{
      setLoading(false);
      message.error(err.message);
    })
  };
  const renderForm = () => {
    return (
      <div className={classnames(styles['login-page'])}>
        <div className={styles['logo']}>招标系统</div>
        <div className={styles['login-wrap']}>
          <div className={styles['login-box']}>
            <h5>账号登录</h5>
            <Form layout="horizontal"
              form={forms}
              onFinish={onFinish}
              initialValues={{ userName: "", passWord: "" }}
              >
                <Form.Item
                  label=""
                  name="userName"
                  rules={[
                      {required:true,message:"请输入账号"},
                  ]}
                >
                  <Input
                    prefix={<img src={userIcon} alt="" />}
                    placeholder="请输入账号"
                    maxLength={200}
                    style={{ height: '55px' }}
                  />
                </Form.Item>
                <Form.Item
                  label=""
                  name="passWord"
                  rules={[
                      {required:true,message:"请输入密码"},
                  ]}
                >
                  <Input.Password
                    prefix={<img src={pswIcon} alt="" />}
                    placeholder="请输入密码"
                    maxLength={200}
                    style={{ height: '55px' }}
                  />
                </Form.Item>
                  <Form.Item
                    className="formItem"
                    style={{ textAlign: "center" }}
                  >   
                    <Button loading={loading} style={{ height: '51px' }} type="primary" block htmlType="submit">登录</Button>
                  </Form.Item>
              </Form>
          </div>
        </div>
      </div>
    )
  }
  return (
    <React.Fragment>
        {renderForm()}
    </React.Fragment>
  )
}

export default UserLogin;
